export default __webpack_public_path__ + "static/media/home2.c6caa9ce.jpg";